<div class="accordion">
    <div class="accordion-item pb-3 mb-3" *ngFor="let item of items">
        <div class="d-flex flex-row justify-content-between" (click)="item.open = !item.open">
            <div [class.sg-link]="!item.open"><b>{{item.title}}</b></div>
            <div class="sg-color">
                <mlp-ng-icon [name]="item.open ? 'subtract-circle' : 'add-circle'"></mlp-ng-icon>
            </div>
        </div>
        <small class="d-block description pr-3" [@ngForAnimationFold]="item.open ? 'opened' : 'closed'" [innerHTML]="item.desc"></small>
    </div>
</div>
